<div #container [ngClass]="isFullScreen ? 'vib-imageContainer-fulscreen' : 'vib-imageContainer'">
	<div class="vib-SensorCanvas" id="locationimage" >
		<img #image *ngIf="inputSubLocation.Level > 1" class="vib-sensorGroupImage"
			src="{{imagePathSubLocations()}}{{inputSubLocation.Id}}?{{inputSubLocation.Modified}}"
			title="{{inputSubLocation.Name}} - {{inputSubLocation.LocationType}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'">

		<div class="tiles-canvas" *ngIf="(width > 0 && height > 0)" [style.left.px]="left" [style.top.px]="top"
			[ngClass]="{'grey-border': sensorEdit}"
			[style.width.px]="width" [style.height.px]="height">
			<app-asset-tile *ngFor="let asset of inputSubLocation.Assets" [accountGUID]="accountGUID"
				[OrganisationUID]="OrganisationUID" [asset]="asset" [imageElement]="imageElement"
				[isFullScreen]="isFullScreen" (click)="assetSelect(asset)"></app-asset-tile>
		</div>
	</div>
	<div class="edit-toolbar" *ngIf="!isFullScreen">
		<span *ngIf="AdminSite">
			<span mat-icon-button class="app-icon app-icon--edit" matTooltip="Edit {{inputSubLocation.Name}} Details"
				matTooltipPosition="above" (click)="editLocation(inputSubLocation)">
				<mat-icon style="padding-bottom: 26px;color: lightgray;" />
			</span>
		</span>
		<span *ngIf="inputSubLocation.Assets && !isMobileView" style="display:flex; flex-direction: column;">
			<span mat-icon-button *ngIf="!sensorEdit" matTooltip="Move Asset Tiles" matTooltipPosition="right"
				class="point-hand" id="edit-btn" aria-disabled="sensorEdit" (click)="moveSensor()">
				<mat-icon style="padding-bottom: 26px;">build</mat-icon>
			</span>
			<span mat-icon-button *ngIf="sensorEdit" matTooltip="Save Tile Positions" matTooltipPosition="right"
				class="point-hand" id="save-btn" aria-disabled="sensorSave" (click)="savePositions(true)">
				<mat-icon style="padding-bottom: 26px;">save</mat-icon>
			</span>
		</span>
	</div>
	<div class="expand-toolbar">
		<span mat-icon-button class="app-icon" [ngClass]="isFullScreen ? 'app-icon--exit-fullscreen' : 'app-icon--fullscreen'"
			[matTooltip]="(!isFullScreen ? 'Expand to ' : 'Exit ') + 'Full Screen'"
			(click)="trueFullscreen(container, !isFullScreen)">
			<mat-icon class="expand-button" />
		</span>
	</div>
</div>